import {Pipe} from "@angular/core";
import {AbstractControl, FormControl, ɵFormGroupRawValue, ɵGetProperty, ɵTypedOrUntyped} from "@angular/forms";

@Pipe({
  name: 'formControlConverter',
  pure: false,
  standalone: true
})
export class FormControlConverterPipe {

  constructor() {
  }

  transform(abstractFormControl: AbstractControl<ɵGetProperty<ɵTypedOrUntyped<any, ɵFormGroupRawValue<any>, any>, "info">> | null): FormControl {
    return abstractFormControl as FormControl;
  }

}
